import { Model } from '@vuex-orm/core'
import Language from './Language'

export default class QuestionCategory extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'questionCategory'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      customer: this.attr(null),
      title: this.attr([
        new Language('en'),
        new Language('de')
      ]),
      createdAt: this.attr('')
    }
  }

  static defaults (langs) {
    return Object.assign(this, {title: langs.map( lang => new Language(lang) )})
  }

  static apiConfig = {}
}